import { Box, VStack, Grid, Separator, Text } from "@chakra-ui/react";
import SectionHeader from "../../CustomUi/SectionHeader";
import { BiPlus, BiCategory } from "react-icons/bi";
import { useSchoolsContext } from "../../../Contexts/schoolContext";
import { useEffect, useState } from "react";
import Loader from "../../CustomUi/Loader";
import CustomAlert from "../../CustomUi/CustomAlert";
import Empty from "../../CustomUi/Empty";
import Cad from "../../CustomUi/Cad";
import { useDisclosure } from "@chakra-ui/react";
import { feeCategoryService } from "../../../services/feeCategoryService";
import { FeeCategoryDto } from "../../../services/Dtos";
import useAxios from "../../../hooks/useAxios";

function FeeCategoriesPage() {
    const { school, accentColor } = useSchoolsContext();
    const axiosClient = useAxios(); // Fix: useAxios returns the instance directly
    const [categories, setCategories] = useState<FeeCategoryDto[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);
    const { onOpen } = useDisclosure(); // TODO: Use onOpen when implementing create modal

    useEffect(() => {
        if (school?.id) {
            loadCategories();
        }
    }, [school]);

    const loadCategories = async () => {
        if (!school?.id || !axiosClient) return;

        try {
            setIsLoading(true);
            const response = await feeCategoryService.getSchoolFeeCategories(axiosClient, school.id);
            if (response.succeeded) {
                setCategories(response.data || []);
            } else {
                setError(response.message);
            }
        } catch (err) {
            setError("Failed to load fee categories");
        } finally {
            setIsLoading(false);
        }
    };

    if (isLoading) {
        return <Loader />;
    }

    if (error) {
        return <CustomAlert message={error} handleClick={loadCategories} />;
    }

    return (
        <VStack gap={8}>
            <Cad>
                <VStack gap={6} align="stretch">
                    <SectionHeader
                        title="Fee Categories"
                        subtitle="Manage fee categories for your school"
                        icon={BiCategory}
                        buttonText="Add Category"
                        onButtonClick={onOpen}
                        buttonIcon={BiPlus}
                        buttonColorScheme={accentColor}
                    />

                    <Separator />

                    {categories.length > 0 ? (
                        <Grid
                            templateColumns={{
                                base: "1fr",
                                md: "repeat(2, 1fr)",
                                xl: "repeat(3, 1fr)",
                            }}
                            gap={6}
                        >
                            {categories.map((category) => (
                                <Cad key={category.id}>
                                    <VStack align="stretch" gap={2}>
                                        <Text fontWeight="bold" fontSize="lg">
                                            {category.name}
                                        </Text>
                                        <Text fontSize="sm" color="gray.600">
                                            {category.description}
                                        </Text>
                                        <Text fontSize="xl" fontWeight="bold" color="brand.500">
                                            ₦{category.amount.toLocaleString()}
                                        </Text>
                                    </VStack>
                                </Cad>
                            ))}
                        </Grid>
                    ) : (
                        <Box py={8}>
                            <Empty
                                message="No fee categories created yet"
                                hasButton
                                buttonText="Create First Category"
                                handleClick={onOpen}
                            />
                        </Box>
                    )}
                </VStack>
            </Cad>
        </VStack>
    );
}

export default FeeCategoriesPage;
